// extracted by mini-css-extract-plugin
export default {"container":"Kga-z","mediaElement":"Lga-z","close":"Mga-z"};